import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">Strona nie została znaleziona</h2>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">Wróć na stronę główną i kontynuuj przeglądanie</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          Strona Główna
        </Link>
      </div>
    </div>
  );
}